export interface IAccount {
  username: string
  lastname: string
  telephone: string
  //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
  referalMobileNo: string,
  //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
  consent1: boolean
  consent2: boolean
  consent3: boolean
  consent4: boolean
  consent5: boolean
  consent6: boolean
}

export const defaultAccount: IAccount = {
  username: '',
  lastname:'',
  telephone:'',
  //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
  referalMobileNo: '',
  //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
  consent1: false,
  consent2: false,
  consent3: false,
  consent4: false,
  consent5: false,
  consent6: false,

}
export interface IOtp {
  OTP1: string
  OTP2: string
  OTP3: string
  OTP4: string
  OTP5: string
  OTP6: string

}

export const defaultOtp: IOtp = {
  OTP1: '',
  OTP2:'',
  OTP3:'',
  OTP4: '',
  OTP5:'',
  OTP6:'',

}

export interface IAccountcustomer {
  email: string
  requireInfo: string
  timeZone: string
  username: string


}

export const defaultAccountcustomer: IAccountcustomer = {
  email: 'bangkoksync',
  requireInfo:'bangkoksync',
  timeZone: 'bangkoksync@loop.com',
  username:'0868138285',


}
